import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";
import type { VacancyFiltersData } from "../types/VacancyTypes";

export const QUERY_KEY = "getVacancies";

interface GetVacancyFiltersParams {
  locale?: string;
  page?: number;
  per_page?: number;
}

export const useGetVacancyFilters = (params?: GetVacancyFiltersParams) => {
  return useQuery({
    queryKey: [QUERY_KEY, params],
    queryFn: async (): Promise<VacancyFiltersData> => {
      const response = await apiClient.get<VacancyFiltersData>(API_ROUTES.vacancyFilters, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      });
      return response.data;
    },
  });
};
